import { render, staticRenderFns } from "./Discussions.vue?vue&type=template&id=713a4363&scoped=true&"
import script from "./Discussions.vue?vue&type=script&lang=js&"
export * from "./Discussions.vue?vue&type=script&lang=js&"
import style0 from "./Discussions.vue?vue&type=style&index=0&id=713a4363&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a4363",
  null
  
)

component.options.__file = "Discussions.vue"
export default component.exports